import './App.css';
import Navbar from './Components/Navbar';
import Allroutes from './Pages/Allroutes';
import Footer from './Components/footer/Footer';

function App() {
  return (
    <>
      <Navbar />
      <Allroutes />
      <Footer />
    </>

  );
}

export default App;
